import React, { useEffect, useMemo } from 'react'
import { format } from 'date-fns'

import { useWatchableRef } from 'lib/hooks'
import { groupMessagesByDate } from '../utils'

import { MessageDay } from './message_day'

function NoMessages({unread}) {
  return <div className="no-messages">There are no { unread ? "recent messages" : "messages" }</div>
}

export function MessageList({messages, scrollToBottom, loading, page, showUnread, finishedPaging}) {
  const ref = useWatchableRef()

  useEffect(() => {
    const container = ref.current
    if (!container || loading || finishedPaging) return

    const handler = scrollToBottom(container)
    container.addEventListener('scroll', handler)
    return () => container.removeEventListener('scroll', scrollToBottom)
  }, [ ref.version, loading, finishedPaging, scrollToBottom])

  const byDate = useMemo(() => groupMessagesByDate(messages), [messages])

  const dates = useMemo(() => Object.keys(byDate), [byDate])
  const today = useMemo(() => format(new Date(), 'yyyy-MM-dd'), [])

  if (messages.length == 0 && !loading)
    return <NoMessages unread={showUnread} />

  return <div className="message-list" ref={ref.ref}>
    { dates.map((date, index) => (
      <MessageDay key={date} 
                  date={date} 
                  previousDate={index > 0 ? dates[index] : today} 
                  messages={byDate[date]} />
      )
    )}
  </div>
}